module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-lg@2x.2d65c9eb.png";